import { gql } from "graphql-tag";

export const getScheduledServices = gql`
  query GetScheduledServices(
    $entrepreneurId: ID!
    $skip: Int
    $first: Int
    $category: String
    $status: [String!]
    $programId: ID
    $searchString: String
    $fromAcceptedDate: DateTime
    $toAcceptedDate: DateTime
    $type: String
  ) {
    scheduledExpertServices(
      orderBy: createdAt_DESC
      where: { 
        status_in: $status
        acceptedAt_gte: $fromAcceptedDate
        acceptedAt_lte: $toAcceptedDate
        assignedExpertService: { 
          expertService: {
            category: $category
            type: $type
          }
          batch: {
            program: {
              id: $programId
            }
          }
          ode: {
            team_some: {
              id: $entrepreneurId
            }
          }
          OR: [
            {
              expertService: {
                OR: [
                  { iname_contains: $searchString },
                  { idescription_contains: $searchString },
                  { expert: { ifullName_contains: $searchString } }
                ]
              }
            },
            {
              batch: { program: { iname_contains: $searchString } }
            },
            {
              batch: { iname_contains: $searchString }
            },
            {
              ode: { iname_contains: $searchString }
            }
          ]
        }
      }
      skip: $skip
      first: $first
    ) {
      id
      status
      duration
      assignedExpertService{
        id
        expertServiceData
        assignmentDate
        limitDate
        status
        batch {
          id
          name
          program {
            id
            name
          }
        }
        expertService {
          id
          name
          type
          category
          duration
        }
        ode {
          id
          name
        }
      }
    }
    meta: scheduledExpertServicesConnection(
      where: {
        status_in: $status
        acceptedAt_gte: $fromAcceptedDate
        acceptedAt_lte: $toAcceptedDate
        assignedExpertService: { 
          expertService: {
            category: $category
            type: $type
          }
          batch: {
            program: {
              id: $programId
            }
          }
          ode: {
            team_some: {
              id: $entrepreneurId
            }
          }
          OR: [
            {
              expertService: {
                OR: [
                  { iname_contains: $searchString },
                  { idescription_contains: $searchString },
                  { expert: { ifullName_contains: $searchString } }
                ]
              }
            },
            {
              batch: { program: { iname_contains: $searchString } }
            },
            {
              batch: { iname_contains: $searchString }
            },
            {
              ode: { iname_contains: $searchString }
            }
          ]
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
